import React from 'react';
import { graphql, Link } from 'gatsby';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { Layout } from 'layouts';
import { Header,PartyList,PartyDetail } from '../components/ContentsComponent';
import config from '../../config/site';

import tasteImage from '../images/taste.jpg';

const StyledLink = styled(Link)`
  color: ${props => props.theme.colors.white.light};
  padding: 5px 10px;
  border: solid 1px #fff;
  border-radius: 20px;
  &:hover {
    color: ${props => props.theme.colors.black.blue};
    background: ${props => props.theme.colors.white.light};
  }
`;


const PostWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 4rem 4rem 1rem 4rem;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    margin: 4rem 2rem 1rem 2rem;
  }
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    margin: 4rem 1rem 1rem 1rem;
  }
`;

const Tag = ({ data,pageContext }) => {
  const { edges } = data.allContentfulFood;
  const { tagName } = pageContext;
  const upperTag = tagName.charAt(0).toUpperCase() + tagName.slice(1);
  return (
    <Layout>
      <Helmet title={tagName} />
      <Header title={upperTag}>
        <StyledLink to="/alltags/">全标签</StyledLink>
      </Header>
      <PartyDetail image={tasteImage} title={`${tagName}結果`} />
      <PostWrapper>
        {edges.map(({ node },index) => {
          const { id, Name, path,price,release,tags,text,mainpic,totalCount } = node;
          return (
            <PartyList
              id={`$tag-{id}`}
              cover={mainpic.fluid}
              path={path}
              title={Name}
              excerpt={text.json}
              tags={tags}
              price={price}
            />
          );
        })}
      </PostWrapper>
    </Layout>
  );
};

export default Tag;

// Tag.propTypes = {
//   pageContext: PropTypes.shape({
//     tagName: PropTypes.string,
//   }),
//   data: PropTypes.shape({
//     allMarkdownRemark :PropTypes.shape({
//       edges :PropTypes.arrayOf(
//         PropTypes.shape({
//           node : PropTypes.shape({
//             excerpt: PropTypes.string,
//             frontmatter : PropTypes.shape({
//               cover: PropTypes.object.isRequired,
//               path: PropTypes.string.isRequired,
//               title: PropTypes.string.isRequired,
//               date: PropTypes.string.isRequired,
//               time: PropTypes.string.isRequired,
//               tags: PropTypes.array,
//               wanted: PropTypes.array,
//               price: PropTypes.array.isRequired,
//             }),
//           }),
//         }).isRequired
//       ),
//     }),
//   }),
// };


export const query = graphql`
    query($tagSlug: String!) {
      allContentfulFood(
        filter: {tags: {elemMatch: {tag: {eq: $tagSlug}}}}
      ){
        edges{
          node{
              id
            Name
            path
            price
            release
            tags{
              tag
            }
            text {
              json
            }
            mainpic{
              fluid(maxWidth:1000,quality:90){
                ...GatsbyContentfulFluid
              }
              title
            }
          }
        }
      }
  }
`;